export default __webpack_public_path__ + "static/media/video-scatter.7f10c0c9.svg";